import fetchApi from 'services/api/connector';

export const fetchLatestTags = (workspace) => fetchApi(`ws/${workspace}/tags?page=0&page_size=5&sort=date&sort_dir=desc`);

export const fetchLatestComments = (workspace) => fetchApi(`ws/${workspace}/comment/filter?q=${JSON.stringify({ limit: 5, offset: 0, order_by: [{ field: 'create_date', direction: 'desc' }], filters: [] })}`);

export const fetchLatestVulns = (ws, confirmed) => fetchApi(`ws/${ws}/vulns?page=0&page_size=5&sort=date&sort_dir=desc${confirmed ? '&confirmed=1' : ''}`);

export const getVulnsCountByStatus = (ws, params = '') => fetchApi(`ws/${ws}/vulns/count?group_by=status${params}`);

export const getVulnsCountBySeverity = (ws, params = '') => fetchApi(`ws/${ws}/vulns/count?group_by=severity${params}`);

export const getTopHostsDashboard = (ws, pageSize = 10) => fetchApi(`ws/${ws}/hosts?page=1&page_size=${pageSize}`);

export const getVulnsCountByMultiWs = (ws, param) => fetchApi(`ws/${ws}/vulns/count_multi_workspace?group_by=severity&workspaces=${ws}${param}`);

export const getTopServicesByName = (ws) => fetchApi(`ws/${ws}/services/count?group_by=name`);

export const getVulnsTimeline = (ws) => fetchApi(`ws/${ws}/vulns/timeline`);

export const getActivitiesList = (ws, page) => fetchApi(`ws/${ws}/activities?page_size=16&page=${page}`);

export const COMMAND_HISTORY_PAGE_SIZE = 16;

export const getCommandHistory = (ws, page) => fetchApi(`ws/${ws}/commands?page_size=${COMMAND_HISTORY_PAGE_SIZE}&page=${page}`);

// TODO: Reemplazar stub por API real cuando backend implemente /api/ws/{ws}/pentest_status
export const fetchPentestStatus = (workspaceId) => {
  return Promise.resolve({
    status: 'in-progress',
    start_date: '2026-06-01',
    end_date: '2026-06-30',
    metrics: {
      open_risk: 12,
      days_remaining: 13,
      workspace_risk: 8.5,
      progress: 45
    }
  });
};

// TODO: Reemplazar stub por API real cuando backend implemente /api/ws/{ws}/vulns/timeline
export const fetchFoundVsClosedTimeline = (workspaceId, days = 15) => {
  const timeline = [];
  const today = new Date();
  for (let i = days - 1; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(date.getDate() - i);
    timeline.push({
      date: date.toISOString().split('T')[0],
      found_count: (i % 10) + 1,
      closed_count: i % 5
    });
  }
  return Promise.resolve({ timeline });
};

// TODO: Reemplazar stub por API real cuando backend implemente /api/ws/{ws}/services?sort=-created_at
export const fetchNewServices = (workspaceId, limit = 5) => {
  const services = [
    { id: 1, name: 'ssh', port: 22, protocol: 'tcp', status: 'open', asset_id: 1, asset_name: 'server-prod', created_at: new Date(Date.now() - 1000 * 60 * 60).toISOString() },
    { id: 2, name: 'http', port: 80, protocol: 'tcp', status: 'open', asset_id: 2, asset_name: 'web-app', created_at: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString() },
    { id: 3, name: 'https', port: 443, protocol: 'tcp', status: 'open', asset_id: 2, asset_name: 'web-app', created_at: new Date(Date.now() - 1000 * 60 * 60 * 48).toISOString() },
    { id: 4, name: 'mysql', port: 3306, protocol: 'tcp', status: 'open', asset_id: 3, asset_name: 'db-server', created_at: null },
    { id: 5, name: 'redis', port: 6379, protocol: 'tcp', status: 'open', asset_id: 4, asset_name: 'cache-server', created_at: new Date(Date.now() - 1000 * 60 * 60 * 72).toISOString() }
  ];
  return Promise.resolve({ services: services.slice(0, limit) });
};

// TODO: Reemplazar stub por API real cuando backend implemente /api/ws/{ws}/hosts?sort=-created_at
export const fetchNewAssets = (workspaceId, limit = 5) => {
  const hosts = [
    { id: 1, name: 'server-prod', ip: '192.168.1.10', hostnames: ['prod.example.com', 'www.example.com'], services_count: 4, created_at: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString() },
    { id: 2, name: 'web-app', ip: '192.168.1.20', hostnames: ['app.example.com'], services_count: 2, created_at: new Date(Date.now() - 1000 * 60 * 60 * 48).toISOString() },
    { id: 3, name: 'db-server', ip: '192.168.1.30', hostnames: [], services_count: 1, created_at: new Date(Date.now() - 1000 * 60 * 60 * 72).toISOString() },
    { id: 4, name: 'cache-server', ip: '192.168.1.40', hostnames: ['cache.internal'], services_count: 3, created_at: new Date(Date.now() - 1000 * 60 * 60 * 96).toISOString() },
    { id: 5, name: 'api-gateway', ip: '192.168.1.50', hostnames: ['api.example.com', 'gateway.example.com'], services_count: 5, created_at: new Date(Date.now() - 1000 * 60 * 60 * 120).toISOString() }
  ];
  return Promise.resolve({ hosts: hosts.slice(0, limit) });
};
